import { render } from "./Floats.vue?vue&type=template&id=5390a7a1&scoped=true"
import script from "./Floats.vue?vue&type=script&lang=js"
export * from "./Floats.vue?vue&type=script&lang=js"

import "./Floats.vue?vue&type=style&index=0&id=5390a7a1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5390a7a1"]])

export default __exports__